import createModel, { prop } from './lib/create_model';
import LookupApiConfig from './lookup_api_config';

export default createModel({
  modelName: 'CustomerLookupConfig',
  properties: {
    adapterType: prop(String).isRequired.default('LOOKUP_API'),
    adapterConfiguration: prop(LookupApiConfig).isRequired,
    disabled: prop(Boolean),
    updatedAt: prop(String),
    autoLinkFields: prop(Array).default([]),
    overwritingEnabled: prop(Boolean).default(false),
  },

  toggleDisabled() {
    this.disabled = !this.disabled;
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/customer_lookup_config.js